import React, { ChangeEvent, InputHTMLAttributes, useCallback } from 'react';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import { mask } from 'remask';
import { Container, Input, Label, Legend } from './styles';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  masks?: string[];
  label?: string | null;
  error?: string | null;
}

const InputForm: React.FC<Props> = (props) => {
  const handle_change = (e: ChangeEvent<HTMLInputElement>) => {
    const { onChange, masks } = props;

    if (masks) {
      e.currentTarget.value = mask(e.currentTarget.value, masks);
    }

    if (onChange) {
      onChange(e);
    }
  };

  return (
    <Container>
      <Label>
        {props.label}
        {props.required && <Legend>*</Legend>}
      </Label>
      <Input {...props} error={Boolean(props.error)} onChange={handle_change} />
      {props.error && (
        <Legend>
          <AiOutlineInfoCircle />
          {props.error}
        </Legend>
      )}
    </Container>
  );
};

export { InputForm };
